import React from 'react'
import { Router, Route, IndexRoute } from 'react-router'

import PageContainer from './containers/PageContainer'
import Home from './components/pages/Home'
import About from './components/pages/About'
import Work from './components/pages/Work'
import Writings from './components/pages/Writings'
import Contact from './components/pages/Contact'
import NotFound from './components/pages/NotFound'

const routes = (
  <Route path="/" component={PageContainer}>
    <IndexRoute component={Home} />
    <Route path="/about" component={About} />
    <Route path="/work" component={Work} />
    <Route path="/writings" component={Writings} />
    <Route path="/contact" component={Contact} />
    <Route path="*" component={NotFound} />
  </Route>
)


const Routes = (props) => (
 <Router {...props}>
   {routes}
 </Router>
)

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.js